import { select, put, SelectEffect, PutEffect } from 'redux-saga/effects';

import { ScribeState } from 'js/types';
import { getScribeById } from 'js/sagas/selectors';
import { EditorKeyboardDeleteAction } from 'js/actionCreators/editorActions';
import { deleteActiveElements, deleteSelectedScenes } from 'js/actionCreators/scribeActions';
import { deleteAudioFromProject } from 'js/actionCreators/audioActions';
import canDeleteScenes from 'js/shared/helpers/canDeleteScenes';
import { KEYBOARD_TRIGGER } from 'js/config/consts';

export function* deleteSaga({
  scribeId
}: EditorKeyboardDeleteAction): Generator<SelectEffect | PutEffect, void, ScribeState> {
  // Determine if we are dealing with scene or elements or nothing and fire off the appropriate action
  const scribe = yield select(getScribeById, scribeId);
  const { selectedSceneIds, activeElements, selectedAudioClip } = (yield select(state => state.scribes)) as ScribeState;

  const hasSelectedScene = selectedSceneIds.length > 0;
  const hasActiveElements = activeElements.length > 0;
  const hasSelectedAudioClip = selectedAudioClip !== null;
  const hasNoActiveSelection = !hasSelectedScene && !hasActiveElements && !hasSelectedAudioClip;
  if (hasNoActiveSelection) return;

  switch (true) {
    case hasSelectedAudioClip:
      if (selectedAudioClip) {
        yield put(deleteAudioFromProject(scribeId, selectedAudioClip.id, KEYBOARD_TRIGGER));
      }
      break;
    case hasSelectedScene:
      const areDeletableScenes = canDeleteScenes(scribe, selectedSceneIds);
      if (!areDeletableScenes) return;
      yield put(deleteSelectedScenes(scribeId, KEYBOARD_TRIGGER));
      break;
    case hasActiveElements:
      yield put(deleteActiveElements(scribeId));
      break;
    default:
      return;
  }
}
